import request from '@/utils/request'

interface LoginParams {
  username: string;
  password: string;
}

interface LoginResponse {
  code: number;
  token?: string;
  msg?: string;
}

export function login({ username, password }: LoginParams): Promise<LoginResponse> {
  return request({
    url: '/login',
    method: 'post',
    data: {
      username,
      password,
    },
  })
}

export function logout(): Promise<any> {
  return request({
    url: '/logout',
    method: 'get',
  })
}

export function getUserInfo(): Promise<any> {
  return request({
    url: '/getUserInfo',
    method: 'get',
  })
}

export function getConfigInfo(): Promise<any> {
  return request({
    url: '/getConfigInfo',
    method: 'get',
  })
}

export function loginByLTI(id: string): Promise<any> {
  return request({
    url: `/lti/login?id=${id}`,
    method: 'get',
  })
}

export function getAuthorizeUrl(): Promise<any> {
  return request({
    url: `/oauth2/getAuthorizeUrl`,
    method: 'get',
  })
}

export function authorizeLogin(id: string): Promise<any> {
  return request({
    url: `/oauth2/login`,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      id,
    },
  })
}

export function getSamlLoginUrl(): Promise<any> {
  return request({
    url: `/saml2/getLoginUrl`,
    method: 'get',
  })
}

export function samlAuthorizeLogin(id: string): Promise<any> {
  return request({
    url: `/saml2/login`,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      id,
    },
  })
}

export function getWenkenAuthorizeUrl(): Promise<any> {
  return request({
    url: `/oauth2/wenken/getAuthorizeUrl`,
    method: 'get',
  })
}

export function wenkenAuthorizeLogin(id: string): Promise<any> {
  return request({
    url: `/oauth2/wenken/login`,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      id,
    },
  })
}

export function getBnbuAuthorizeUrl(): Promise<any> {
  return request({
    url: `/oauth2/bnbu/getAuthorizeUrl`,
    method: 'get',
  })
}

export function bnbuAuthorizeLogin(id: string): Promise<any> {
  return request({
    url: `/oauth2/bnbu/login`,
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    data: {
      id,
    },
  })
}

export function authorizeCallback(code: string): Promise<any> {
  return request({
    url: `/oauth2/login`,
    method: 'post',
    data: {
      code,
    },
  })
}

/**
 * 获取学校配置列表（供登录页选择学校）
 */
export function getSchoolConfigList(): Promise<any> {
  return request({
    url: '/studentEnd/getSchoolConfigList',
    method: 'post',
  })
}
